import * as React from 'react';
import { BLACKS_AND_WHITES } from '../../utils/DataFormatterUtils';
import {
	ENTITY_ADD_REQUEST_STATUSES,
	ENTITY_ADD_REQUEST_STATUS_DISPLAY_NAMES,
	ENTITY_ADD_REQUEST_STATUS_DISPLAY_TEXT_COLORS,
	ENTITY_ADD_REQUEST_STATUS_DISPLAY_BACKGROUND_COLORS,
} from '../../constants/EntityAddRequestStatuses';

const EntityAddRequestStatusDisplay = ({
	status,
	darkMode = false,
	style = {},
	textStyle = {},
	...props
}) => {
	if (!Object.keys(ENTITY_ADD_REQUEST_STATUSES).includes(status)) {
		return null;
	}
	let statusColor = ENTITY_ADD_REQUEST_STATUS_DISPLAY_TEXT_COLORS[status];
	const statusDisplayName = ENTITY_ADD_REQUEST_STATUS_DISPLAY_NAMES[status];
	const statusBackgroundColor = ENTITY_ADD_REQUEST_STATUS_DISPLAY_BACKGROUND_COLORS[status];

	if (darkMode) {
		statusColor = BLACKS_AND_WHITES.whiteSecondary;
	}

	return (
		<span
			{...props}
			style={{
				color: statusColor,
				background: statusBackgroundColor,
				padding: '4px 12px',
				borderRadius: 16,
				whiteSpace: 'nowrap',
				...style,
				...textStyle,
			}}
		>
			{statusDisplayName}
		</span>
	);
};

export default EntityAddRequestStatusDisplay;
